import { render, staticRenderFns } from "./DateIcon.vue?vue&type=template&id=228f37d5&scoped=true&"
import script from "./DateIcon.vue?vue&type=script&lang=js&"
export * from "./DateIcon.vue?vue&type=script&lang=js&"
import style0 from "./DateIcon.vue?vue&type=style&index=0&id=228f37d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f37d5",
  null
  
)

export default component.exports